var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6571 3.75032C26.5336 0.504126 21.4596 0.504126 18.3228 3.75032L16.9998 5.1279L15.6768 3.75032C12.5534 0.504126 7.47929 0.504126 4.34258 3.75032C1.21914 6.99651 1.21914 12.2475 4.34258 15.4941L16.9727 28.6018L17 28.5745L17.0273 28.6018L29.6574 15.4941C32.7809 12.2479 32.7809 6.99687 29.6574 3.75032H29.6571Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5476 5.84454C24.9447 3.13938 20.7163 3.13938 18.1024 5.84454L16.9998 6.99253L15.8973 5.84454C13.2945 3.13938 9.06608 3.13938 6.45215 5.84454C3.84928 8.54971 3.84928 12.9255 6.45215 15.631L16.9773 26.5541L17 26.5314L17.0227 26.5541L27.5479 15.631C30.1507 12.9259 30.1507 8.55001 27.5479 5.84454H27.5476Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.438 7.93877C23.3557 5.77464 19.973 5.77464 17.8819 7.93877L16.9999 8.85716L16.1179 7.93877C14.0356 5.77464 10.6529 5.77464 8.56172 7.93877C6.47943 10.1029 6.47943 13.6036 8.56172 15.7679L16.9818 24.5064L17 24.4882L17.0182 24.5064L25.4383 15.7679C27.5206 13.6038 27.5206 10.1031 25.4383 7.93877H25.438Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3285 10.033C21.7668 8.4099 19.2298 8.4099 17.6614 10.033L16.9999 10.7218L16.3384 10.033C14.7767 8.4099 12.2396 8.4099 10.6713 10.033C9.10957 11.6561 9.10957 14.2816 10.6713 15.9049L16.9864 22.4587L17 22.4451L17.0136 22.4587L23.3287 15.9049C24.8904 14.2818 24.8902 11.6563 23.3285 10.033Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4179 11.8027C20.3119 10.6533 18.5153 10.6533 17.4046 11.8027L16.9362 12.2905L16.4677 11.8027C15.3618 10.6533 13.5651 10.6533 12.4545 11.8027C11.3485 12.9522 11.3485 14.8115 12.4545 15.961L16.9266 20.6022L16.9363 20.5926L16.9459 20.6022L21.418 15.961C22.524 14.8116 22.5239 12.9523 21.4179 11.8027Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9393 13.2687C19.1977 12.498 17.9931 12.498 17.2484 13.2687L16.9343 13.5958L16.6201 13.2687C15.8786 12.498 14.6739 12.498 13.9292 13.2687C13.1877 14.0394 13.1877 15.2861 13.9292 16.0569L16.9278 19.1689L16.9343 19.1624L16.9408 19.1689L19.9394 16.0569C20.6809 15.2862 20.6808 14.0395 19.9393 13.2687Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4646 14.7347C18.0874 14.3427 17.4747 14.3427 17.096 14.7347L16.9362 14.901L16.7765 14.7347C16.3993 14.3427 15.7866 14.3427 15.4079 14.7347C15.0307 15.1266 15.0307 15.7607 15.4079 16.1527L16.933 17.7355L16.9362 17.7322L16.9395 17.7355L18.4646 16.1527C18.8418 15.7607 18.8417 15.1267 18.4646 14.7347Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart3);
export default __webpack_public_path__ + "static/media/Heart-3.6101f07e788424a3e5c416b5a042e355.svg";
export { ForwardRef as ReactComponent };